import { API_BASE_URL, APP_ROLE } from '@/config/env'
import { SOCKET_EVENTS } from '@/entities/order/socket/events'
import { joinClientOrderRoom } from '@/entities/order/socket/joins'
import { useClientOrdersStore } from '@/features/client-orders/model/useClientOrdersStore'
import { connectSocket, getSocket } from '@/shared/socket/socketClient'
import { useAuthStore } from '@/stores/auth'

let joinedOrderId = null
let isClientRealtimeStarted = false

function handleOrderStatusChanged(payload) {
  useClientOrdersStore().applyStatusUpdate(payload ?? {})
}

function handleOrderCourierLocation(payload) {
  useClientOrdersStore().patchCourierLocation(payload ?? {})
}

function handleSocketConnect() {
  const orderId = useClientOrdersStore().activeOrder?.id
  if (!orderId) {
    return
  }
  joinedOrderId = null
  syncClientOrderRoom(orderId)
}

export function syncClientOrderRoom(orderId, { force = false } = {}) {
  const id = orderId != null && orderId !== '' ? String(orderId) : null
  if (!id || (!force && joinedOrderId === id)) {
    return
  }
  joinClientOrderRoom(id)
  joinedOrderId = id
}

function bindClientSocketHandlers(socket) {
  socket.off('connect', handleSocketConnect)
  socket.on('connect', handleSocketConnect)

  socket.off(SOCKET_EVENTS.client.STATUS_CHANGED, handleOrderStatusChanged)
  socket.on(SOCKET_EVENTS.client.STATUS_CHANGED, handleOrderStatusChanged)

  socket.off(SOCKET_EVENTS.client.COURIER_LOCATION, handleOrderCourierLocation)
  socket.on(SOCKET_EVENTS.client.COURIER_LOCATION, handleOrderCourierLocation)
}

function unbindClientSocketHandlers(socket) {
  if (!socket) {
    return
  }
  socket.off('connect', handleSocketConnect)
  socket.off(SOCKET_EVENTS.client.STATUS_CHANGED, handleOrderStatusChanged)
  socket.off(SOCKET_EVENTS.client.COURIER_LOCATION, handleOrderCourierLocation)
}

export async function startClientRealtime() {
  if (APP_ROLE !== 'client' || !API_BASE_URL) {
    return
  }

  const authStore = useAuthStore()
  if (!authStore.isLoggedIn) {
    return
  }

  const ordersStore = useClientOrdersStore()
  const orderId = ordersStore.activeOrder?.id
  if (!orderId) {
    return
  }

  try {
    const socket = await connectSocket()
    if (!socket) {
      return
    }

    bindClientSocketHandlers(socket)
    isClientRealtimeStarted = true

    if (socket.connected) {
      handleSocketConnect()
    }
  } catch (error) {
    console.warn('[realtime] client socket connect failed', error)
  }
}

export function stopClientRealtime() {
  if (isClientRealtimeStarted) {
    unbindClientSocketHandlers(getSocket())
    isClientRealtimeStarted = false
  }
  joinedOrderId = null
}
